import { Component, OnInit, ViewChild } from '@angular/core';
import {DxFormComponent, DxFormModule} from 'devextreme-angular';
import {PrintFileService} from "@dabnet-kamu/libs/ui/shared/services/print-file.service";
import {NgClass} from "@angular/common";
import {JSPrintManager, WSStatus} from "jsprintmanager";
import {UtilsService} from "@dabnet-kamu/libs/ui/shared/services/utils.service";
import {DkGlobalUserSettingsService} from "@dabnet-kamu/libs/ui/shared/services/dk-global-user-settings.service";
import {FormMetadataService} from "@dabnet-kamu/libs/ui/shared/services/form-metadata.service";



// Bu DTO, form verilerini tutar.
export class PrintTestDto {
  printType: string;
  printFile: string;
  printerName: string;

  constructor(item?: any) {
    this.printType = item?.printType;
    this.printFile = item?.printFile;
    this.printerName = item?.printerName;
  }
}

@Component({
  selector: 'app-test-print',
  standalone: true,
  templateUrl: './test-print.component.html',
  imports: [
    DxFormModule,
    NgClass
  ],
  styleUrls: ['./test-print.component.scss']
})
export class TestPrintComponent implements OnInit {

  formDto: PrintTestDto = new PrintTestDto({});
  yaziciTipiList = [
    { id: 'W', name: 'Windows (PDF, Görüntü)' },
    { id: 'D', name: 'Dot Print (RAW Komut)' }
  ];
  yaziciList: any[] = [];
  wsStatusMessage: string = 'JSPM istemci bağlantısı bekleniyor...';
  wsStatusType: 'success' | 'error' | 'warning' = 'warning';
  labelMode: any;
  labelLocation: any;
  @ViewChild(DxFormComponent, { static: false }) form: DxFormComponent;

  constructor(
    private dkGlobalUserSettingsService: DkGlobalUserSettingsService,
    private utilsService: UtilsService,
    private formMetadataService: FormMetadataService,
    private printService: PrintFileService
  ) {
    this.labelMode = this.dkGlobalUserSettingsService.globalLabelMode;
    this.labelLocation = this.dkGlobalUserSettingsService.globalLabelLocation;
  }

  ngOnInit(): void {
    JSPrintManager.auto_reconnect = true;
    JSPrintManager.start();
    JSPrintManager.WS.onStatusChanged = () => {
      this.updateJspmStatus();
      if (this.isJspmConnected()) {
        JSPrintManager.getPrinters().then((installedPrinters: any) => {
          this.yaziciList = installedPrinters.map((p: string) => ({ id: p, name: p }));
        }).catch(() => {
          this.wsStatusMessage = 'Yazıcı listesi alınamadı.';
          this.wsStatusType = 'error';
        });
      } else this.yaziciList = [];
    };
  }

  updateJspmStatus(): boolean {
    const status = JSPrintManager.websocket_status;
    switch (status) {
      case WSStatus.Open:
        this.wsStatusMessage = 'JSPM Bağlantısı Başarılı. Yazıcıları seçebilirsiniz.';
        this.wsStatusType = 'success';
        return true;
      case WSStatus.Closed:
        this.wsStatusMessage = 'JSPM yüklü değil veya çalışmıyor.';
        this.wsStatusType = 'error';
        return false;
      case WSStatus.Blocked:
        this.wsStatusMessage = 'JSPM engellendi.';
        this.wsStatusType = 'error';
        return false;
      default:
        this.wsStatusMessage = 'JSPM bağlantı durumu bilinmiyor.';
        this.wsStatusType = 'warning';
        return false;
    }
  }

  isJspmConnected(): boolean {
    return JSPrintManager.websocket_status === WSStatus.Open;
  }

  // TestPrintComponent sınıfı içinde
// ... (Diğer metodlar)

  async submitForm($e: any) {
    if (!this.formDto?.printerName || !this.formDto?.printType) {
      this.utilsService.showError('Lütfen Yazıcı Tipi ve Yazıcı Adı seçin.');
      return;
    }

    // JSPM bağlantısı açık değilse, servis zaten bekleyecek/hata verecektir.
    // Ancak kullanıcıya hızlı geri bildirim için bu kontrol kalabilir:
    // if (!this.isJspmConnected()) { /* ... */ }

    // --- TEST İÇİN YAZICI ADINI ZORLA GEÇERSİZ KILMA ---
    // Test ortamınızda kurulu olan SANAL PDF yazıcısının tam adını girin.
    const TEST_PRINTER_NAME = "Microsoft Print to PDF";

    let targetPrinter = this.formDto.printerName;
    let fileContent: string;
    let printerType = this.formDto.printType as 'W' | 'D';

    // Varsayılan olarak seçilen yazıcıyı kullanıyoruz, ancak PDF baskı testi için
    // TEST_PRINTER_NAME'i kullanmayı zorlayabilirsiniz (Tavsiye edilir).

    if (printerType === 'W') {
      // W (PDF) tipi için sanal yazıcıya yönlendirmeyi zorla
      targetPrinter = TEST_PRINTER_NAME;

      // Örnek Base64 içeriği (kendi verinizle değiştirildi)
      const base64PDF = 'JVBERi0xLjQKJcOcxrEKBjEgMCBvYmoKPDwvVHlwZSAvQ2F0YWxvZwovUGFnZXMgMiAwIFIKPj4KZW5kb2JqCjIgMCBvYmoKPDwvVHlwZSAvUGFnZXMKL0tpZHMgWzMgMCBSXQovQ291bnQgMQo+PgplbmRvYmoKMyAwIG9iago8PC9UeXBlIC9QYWdlCi9NZWRpYUJveCBbMCAwIDU5NSA4NDJdCi9QYXJlbnQgMiAwIFIKL1Jlc291cmNlcyA8PC9Gb250IDw8L0YxIDQgMCBSPj4vUHJvY1NldCBbL1BkZlRleHRdID4+Ci9Db250ZW50cyA1IDAgUgo+PgplbmRvYmoKNCgwIG9iagq8PC9UeXBlIC9Gb250Ci9TdWJ0eXBlIC9UeXBlMQovQmFzZUZvbnQgL0hlbHZldGljYQovRW5jb2RpbmcgL1dpbmFuc2lFbmNvZGluZwo+PgplbmRvYmoKNSwwIG9iagooQlQKL0YxIDE0IFRmLnQKNzIgNzMyIFRkCihURVNULyBUZXN0KSBUagpFVCkgCmVuZG9iagpYcmVmCjAgNgowMDAwMDAwMDAwIDY1NTM1IGYKMDAwMDAwMDAwOSAwMDAwMCBuCjAwMDAwMDAwNTcgMDAwMDAgbgowMDAwMDAwMTQ2IDAwMDAwIG4KMDAwMDAwMDI1MyAwMDAwMCBuCjAwMDAwMDAzMDUgMDAwMDAgbgp0cmFpbGVyCjw8L1Jvb3QgMSAwIFIKL1NpemUgNgovSW5mbyA2IDAgUgo+PgVzdGFydHhyZWYKMzQ1CnUlJUZPRQoK';
      fileContent = base64PDF;

    } else {
      // D (RAW) tipi için orijinal yazıcı adını koru (ya da test için yine sanalı dene)
      const rawBase64 = 'MjAsMjAsMjAwMCw0MDAsIjIiClwxMCwyNDEsIjEwLjk0IiwiMTcuOTQiLCJjb25zb2xlIiwiQUMiClw';
      fileContent = rawBase64;
    }


    // Baskı servisini çağır ve sonucu bekle
    const result = await this.printService.print(
      targetPrinter,
      fileContent,
      printerType,
      true // silent: true (Pop-up açılmasını engeller, Microsoft Print to PDF için kritiktir)
    );

    if (result.success) {
      console.log("Baskı komutu başarıyla gönderildi (Component).");
      this.wsStatusMessage = 'Baskı komutu başarıyla gönderildi.';
      this.wsStatusType = 'success';
    } else {
      console.error("Baskı hatası (Component):", result.error);
      this.wsStatusMessage = `Baskı hatası: ${result.error}`;
      this.wsStatusType = 'error';
    }
  }
}
